import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Project} from "../../../../types/sherpa";
import {AdminService} from "../../../../services/data/admin.service";
import {MapService} from "../../../../services/map.service";
import _ from 'lodash';

@Component({
	selector: 'project-detail',
	templateUrl: './project-detail.component.html',
	styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {

	@Input() inputProject: Project;
	@Output() discardRequest = new EventEmitter<Project>();
	@Output() updateRequest = new EventEmitter<Project>();

	constructor(private projectService: AdminService, private mapService: MapService) {

	}

	ngOnInit(): void {

	}

	submit() {
		this.updateRequest.emit(this.inputProject);
	}

	discardProject() {
		this.discardRequest.emit(this.inputProject);
	}

}
